// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"195367db","56":"87dd2416","65":"cf048a5a","170":"a6cb6ea0","197":"31601b51","238":"2b391825","319":"5825c76f","344":"a28fa9dc","453":"3f038b64","499":"7fde8bec","612":"8a109b4e","849":"7145eccc","908":"933fb420"}[chunkId] + ".chunk.js";
};